FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    function ControlMessage() {}

    ControlMessage.prototype = {
        setSpinnerOff: function () {
            setTimeout(function () {
                me.unsetTopProgressBar();
            }, 300);
        },
        setSpinner: function () {
            me.setTopProgressBar();
        },
        setSpinnerDelay: function(delay){
            this.setSpinner();
            var that = this;
            setTimeout(function () {
                me.unsetTopProgressBar();
            }, delay);
        },
        setMessage: function (result, message) {
            me.unsetTopProgressBar();
        }
    };


    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set message
    child.setMessageContainer = function () {
        return new ControlMessage();
    }



    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));